import React, {Component} from 'react'
import {InfoBlock} from '../InfoBlock'
import {Title} from '../Title'
import {Grid} from '../Grid'

import './info-block-grid.css'

const nCellsPerRowMobile = 1;

class InfoBlockGrid extends Component {

  render() {
    let title = this.props.title ? <Title name={this.props.title}></Title> : null;
    let sizes = this.props.sizes;

    let data = this.props.data.map(
      (datum, index) =>
        <InfoBlock
          descriptionStyleMod = {this.props.descriptionStyleMod ? this.props.descriptionStyleMod : {}}
          containsImage={true}
          hasModalImage ={this.props.hasModalImage}
          data={datum}
          sizes = {sizes[index]}>
        </InfoBlock>
        );

    return (
      <div>
        {title}
        <Grid
          marginTop = {50}
          data = {data}
          nCellsPerRow = {this.props.nCellsPerRow}
          nCellsPerRowMobile = {this.props.nCellsPerRowMobile}>
        </Grid>
      </div>
    );
  }
}

export default {InfoBlockGrid}



// WEBPACK FOOTER //
// ./src/components/InfoBlockGrid/index.js